import React, { useState, useEffect, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import { setSelectedFacebookPage } from '../../../../../store/actions/facebook-messenger';
import { searchUserPages } from './facebook-api';

/**
 * Component for show user, the pages that he share with our facebook app
 *
 * @param {*} props
 * @returns
 */
const ChannelFacebookMessengerPageList = (props) => {
  const { facebookAuth, selectedFacebookPage, setSelectedFacebookPage } = props;

  const [pages, setPages] = useState([]);

  /**
   * Called when component mount for getting the Facebook user page list
   */
  useEffect(() => {
    searchUserPages(facebookAuth).then((resolve) => setPages(resolve));
  }, []);

  /**
   * Called when user try to change the selected Facebook page for the current bot
   * @param {Object} event
   */
  const onFacebookPageSelectedChange = (event) => {
    const id = event.currentTarget.value;
    const newPageSelected = _.find(pages, (page) => page.id === id);
    if (newPageSelected) {
      setSelectedFacebookPage(newPageSelected);
    }
  };

  /**
   * Render Facebook user page list jsx
   */
  const renderUserPagesList = () => {
    if (pages.length > 0) {
      return _.map(pages, (page, index) => {
        const { id, picture, name } = page;
        const { height, width, url } = picture.data;
        const imgStyle = { height, width, borderRadius: 50 };
        const lineStyle = {
          backgroundColor: `${index % 2 === 0 ? '#E9EBEE' : ''}`,
        };

        return (
          <div key={id} style={lineStyle} className="page-line-info">
            <div className="container-user-pages-line-info">
              <input
                type="radio"
                name="same"
                className="page-select-radio"
                checked={selectedFacebookPage.id === id}
                value={id}
                onChange={onFacebookPageSelectedChange}
              />
              <img src={url} style={imgStyle} alt="" />
              <p className="user-pages-name">{name}</p>
            </div>
          </div>
        );
      });
    }
    return false;
  };

  return (
    <Fragment>
      <p className="user-pages">Suas páginas</p>
      {renderUserPagesList()}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    facebookAuth: state.facebookMessenger.facebookAuth,
    selectedFacebookPage: state.facebookMessenger.selectedFacebookPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setSelectedFacebookPage }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerPageList))
);
